import { Container, Paper, Typography } from "@mui/material"
import { ResumenEstudiante } from "./ResumenEstudiante"
import { TablaAyudAcad } from "./TablaAyudAcad"


export const ActividadesAcademicas: React.FC = () =>{
    return(
        <Paper elevation={3} sx={{ padding: 2, marginBottom: 3}}>
            <Container sx={{display: "flex",             
                            flexDirection: "column", alignItems:"center"}}>
                <Typography
                    variant="h5"
                    sx={{
                    fontWeight: "bold",
                    color: "#243165",
                    marginBottom: "24px",
                    
                    }}
                >
                    Consulta de Materias de Ayudantías de Docencia
                </Typography>
            </Container>
    
            <Container>
                <ResumenEstudiante />
            </Container>

            <Container>
                <TablaAyudAcad />
            </Container>

        </Paper>
        
    )
}